import { useContext, useEffect, useState } from "react";
import { GET_ALL_EVENTS_BY_CAT_ID, GET_EVENTS_CATEGORIES, fetchData } from "../../../components/Service";
import { Context } from "../../../components/Context";
import moment from "../../../../node_modules/moment/moment";
import { Link } from "../../../../node_modules/react-router-dom/dist/index";

const NationalEvents = () => {
	const [eventCat, setEventCat] = useState([]);
	const [catId, setCatId] = useState("");
	const [catName, setCatName] = useState("");
	const [events, setEvents] = useState([]);
	const [context] = useContext(Context);

	const getEventCat = () => {
		fetchData(GET_EVENTS_CATEGORIES, "GET", "", false, false, (res) => {
			if (res.status) {
				setEventCat(res?.data);
				setCatId(res?.data[0]?.id);
				setCatName(res?.data[0]?.name);
			} else {
				console.log(res);
			}
		});
	};

	const getEvents = (country_id, state_id, cat_id) => {
		fetchData(GET_ALL_EVENTS_BY_CAT_ID, "POST", { country_id: country_id, state_id: state_id, category_id: cat_id }, false, false, (res) => {
			if (res.status) {
				setEvents(res?.data?.data?.data);
			} else {
				setEvents([]);
			}
		});
	};

	useEffect(() => {
		getEventCat();
	}, []);

	useEffect(() => {
		if (context?.countryId && context?.stateId && catId) {
			getEvents(context?.countryId, context?.stateId, catId);
		}
	}, [catId, context?.stateId]);
	return (
		<div class="col-xl-6 mb-4 mb-xl-0">
			<div class="card  ">
				<div class="card-header usa-bg py-1">
					<div className="national-bg">
						<h6 class="text-white d-flex ind1">{context?.stateView ? "State Events" : "National Events"}</h6>
					</div>
				</div>
				<div class="card-body p-1">
					<div class="text-center">
						<div class="list-tabs mt-0">
							<ul class="nav nav-tabs nav-tabsbg" role="tablist">
								{eventCat?.map((item, index) => (
									<li
										key={index}
										onClick={() => {
											setCatId(item.id);
											setCatName(item.name);
										}}
									>
										<a
											class={item.id === catId ? "active" : ""}
											id={`nav-tab-job-${catId}`}
											href={`#tab-job-${catId}`}
											data-bs-toggle="tab"
											role="tab"
											aria-controls={`tab-job-${catId}`}
											aria-selected={item.id === catId}
										>
											{item.name}
										</a>
									</li>
								))}
							</ul>
						</div>
					</div>
					<div class="mt-2">
						<div class="tab-content" id={`myTabContent-${catId}`}>
							<div class="tab-pane fade show active" id={`tab-job1-${catId}`} role="tabpanel" aria-labelledby={`tab-job1-${catId}`}>
								<div class="row align-items-stretch">
									{events && events.length > 0 ? (
										events.slice(0, 6)?.map((item) => (
											<div key={item.id} class="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 event_n mb-1">
												<div class="card-grid-2 hover-up h-100 mb-0">
													<Link to={`/events/${item.id}`}>
														<div class="ne-img">
															<img src={item.image} alt="..." />
														</div>
													</Link>
													<span class="stick">{catName}</span>
													<div class="card-block-info position-relative">
														<span class="view">
															<img src="/assets/images/icons/view.png" alt="..." /> {item.total_views}
														</span>
														<h6>
															<Link to={`/events/${item.id}`}>{item.title}</Link>
														</h6>
														<p class="color-text-paragraph mt-1">{item.address}</p>

														<div class="card-2-bottom mt-30">
															<div class="row d-flex align-items-center">
																<div class="col-7 d-flex align-items-center">
																	<img src="/assets/images/icons/cal.png" class="me-2" alt="..." />
																	<span class="text-muted">{item.created_at ? moment(item.created_at).format("DD-MMM-YYYY") : ""}</span>
																</div>
																<div class="col-5 ps-0 text-end">
																	<Link to={`/events/${item.id}`} class="btn btn-apply-now">
																		View More
																	</Link>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										))
									) : (
										<div className="text-center h5 text-danger"></div>
									)}
								</div>
							</div>
						</div>
					</div>
					{events && events.length > 0 ? (
						<div class="row">
							<div class="col-md-12 text-center">
								<Link to={`/events`} class="btn btn-warning fw-bold mx-auto">
									Read More
								</Link>
							</div>
						</div>
					) : (
						""
					)}
				</div>
			</div>
		</div>
	);
};

export default NationalEvents;
